/**
 * Megamenu Image Preloader
 * Preloads megamenu images when the user opens the megamenu (desktop) or drawer (mobile)
 * to eliminate loading delays when switching between tabs
 */

class MegamenuImagePreloader {
  constructor() {
    this.desktopPreloaded = false;
    this.mobilePreloaded = false;
    this.init();
  }

  init() {
    this.initDesktopPreload();
    this.initMobilePreload();
  }

  /**
   * Desktop: Preload images when megamenu is hovered
   */
  initDesktopPreload() {
    const megamenuItems = document.querySelectorAll('.header__nav-item.megamenu');

    megamenuItems.forEach(item => {
      item.addEventListener('mouseenter', () => {
        if (window.innerWidth >= 990 && !this.desktopPreloaded) {
          this.preloadMegamenuImages('.header__nav-dropdown-inner--products');
          this.desktopPreloaded = true;
        }
      }, { once: false }); // Not using once in case menu is closed and reopened
    });
  }

  /**
   * Mobile: Preload images when navigation drawer is opened
   */
  initMobilePreload() {
    const drawer = document.querySelector('header-drawer');

    if (!drawer) return;

    // Use MutationObserver to detect when drawer opens (details[open] attribute)
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
          const details = drawer.querySelector('details[open]');
          if (details && !this.mobilePreloaded) {
            this.preloadMegamenuImages('.mobile-megamenu-wrapper');
            this.mobilePreloaded = true;
            // Disconnect observer after first preload for efficiency
            observer.disconnect();
          }
        }
      });
    });

    // Observe the details element inside the drawer
    const details = drawer.querySelector('details');
    if (details) {
      observer.observe(details, { attributes: true });
    }
  }

  /**
   * Preload all megamenu images within a container
   * Converts data-src -> src, data-srcset -> srcset, data-sizes -> sizes
   */
  preloadMegamenuImages(containerSelector) {
    const container = document.querySelector(containerSelector);

    if (!container) {
      return;
    }

    const images = container.querySelectorAll('.megamenu-preload-image');

    images.forEach((img) => {
      // Convert data-src to src
      if (img.dataset.src) {
        img.src = img.dataset.src;
        delete img.dataset.src;
      }

      // Convert data-srcset to srcset
      if (img.dataset.srcset) {
        img.srcset = img.dataset.srcset;
        delete img.dataset.srcset;
      }

      // Convert data-sizes to sizes
      if (img.dataset.sizes) {
        img.sizes = img.dataset.sizes;
        delete img.dataset.sizes;
      }
    });

  }
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new MegamenuImagePreloader();
  });
} else {
  new MegamenuImagePreloader();
}
